import { GridRowParams } from '@material-ui/data-grid';
import { observer } from 'mobx-react-lite';
import VMDataGrid from '../../components/main/VMDataGrid';
import TextLink from '../../components/other/TextLink';
import { gridColumn } from '../../utils/gridUtils';
import { LOCATION_DETAILS_TABS, locationDetailsTabParameters } from '../../utils/routing';

const CatalogEntriesPage = observer(({ data }: { data: any[] }) => {
  const catalogColumns = [
    gridColumn('name', {
      headerName: 'Location Name',
      flex: 2,
      minWidth: 150,
      renderCell: (params: GridRowParams) => (
        <div style={{ display: 'flex', flexDirection: 'column', lineHeight: 'normal' }}>
          <TextLink
            to={locationDetailsTabParameters(
              params.row.location?.id,
              LOCATION_DETAILS_TABS.OVERVIEW,
            )}
            label={params.row.location?.name || ''}
            divStyle={{ marginBottom: '0.375rem' }}
          />
          <span style={{ color: 'gray', fontSize: '0.9rem' }}>{`${
            params.row.location?.address || ''
          }, ${params.row.location?.zip || ''}, ${params.row.location?.city || ''}`}</span>
        </div>
      ),
    }),
    gridColumn('chargePointName', {
      headerName: 'Charge Point OCPP ID',
      flex: 2,
      minWidth: 150,
      renderCell: (params: GridRowParams) => <div>{params.row.chargePoint?.ocppId || 'N/A'}</div>,
    }),
    gridColumn('chargePointType', {
      headerName: 'Charge Point Manufacturer',
      flex: 2,
      minWidth: 150,
      renderCell: (params: GridRowParams) => (
        <div>{params.row.chargePoint?.manufacturer || ''}</div>
      ),
    }),
  ];

  return (
    <VMDataGrid rows={data} columns={catalogColumns} label="Assigned Locations and Charge Points" />
  );
});

export default CatalogEntriesPage;
